module.exports = __webpack_public_path__ + "img/booth-outline-blue.d159de29.png";